import React from "react";

function EmptyLoading() {
  return <></>;
}

export default EmptyLoading;
